import {CaloriesCalculationMethod} from "@/models/Recipes/CaloriesCalculationMethod";
import {DailyValueCalculationMethod} from "@/models/Recipes/DailyValueCalculationMethod";
import {ProteinDailyValueCalculationMethod} from "@/models/Recipes/ProteinDailyValueCalculationMethod";

export class CalculationMethodModalData {
  isOpen: boolean;
  selectedCalculationMethod: CaloriesCalculationMethod;
  selectedDailyValueCalculation: DailyValueCalculationMethod;
  selectedProteinDailyValueCalculation: ProteinDailyValueCalculationMethod;
  pdcaasScore: number;

  constructor(
    isOpen: boolean = false,
    selectedCalculationMethod: CaloriesCalculationMethod = CaloriesCalculationMethod.Summation,
    selectedDailyValueCalculation: DailyValueCalculationMethod = DailyValueCalculationMethod.Rounded,
    selectedProteinDailyValueCalculation = ProteinDailyValueCalculationMethod.Default,
    pdcaasScore: number = 1
  ) {
    this.isOpen = isOpen;
    this.selectedCalculationMethod = selectedCalculationMethod;
    this.selectedDailyValueCalculation = selectedDailyValueCalculation;
    this.selectedProteinDailyValueCalculation = selectedProteinDailyValueCalculation;
    this.pdcaasScore = pdcaasScore;
  }

  openModal() {
    this.isOpen = true;
  }

  closeModal() {
    this.isOpen = false;
  }
}